"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var boolean_schema_1 = __importDefault(require("./boolean.schema"));
exports["default"] = boolean_schema_1["default"];
//# sourceMappingURL=index.js.map